var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 19,
    viewBox: "0 0 31 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1387_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6992 18.4678V0.46875H18.7099V18.4678H14.6992ZM25.5329 18.4678L20.2995 10.7889H24.7014L30.1794 18.4678H25.5329ZM17.6338 12.7453V9.59056H22.0358C22.6227 9.59056 23.1281 9.47644 23.552 9.24819C23.9922 9.00364 24.3264 8.66942 24.5547 8.24552C24.7992 7.80533 24.9215 7.29992 24.9215 6.7293C24.9215 6.15867 24.7992 5.66142 24.5547 5.23753C24.3264 4.79733 23.9922 4.46311 23.552 4.23486C23.1281 3.99031 22.6227 3.86803 22.0358 3.86803H17.6338V0.46875H21.7179C23.2015 0.46875 24.4895 0.697 25.5818 1.1535C26.6741 1.59369 27.5138 2.25398 28.1007 3.13437C28.6876 4.01476 28.9811 5.1234 28.9811 6.46029V6.85157C28.9811 8.17216 28.6795 9.27265 28.0762 10.153C27.4893 11.0171 26.6497 11.6693 25.5574 12.1095C24.4813 12.5333 23.2015 12.7453 21.7179 12.7453H17.6338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.179688 18.4656V0.613281H4.09253V18.4656H0.179688ZM3.60342 18.4656V15.1397H11.4047V18.4656H3.60342ZM3.60342 11.0557V7.72976H10.8422V11.0557H3.60342ZM3.60342 3.9392V0.613281H11.2335V3.9392H3.60342Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1387_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9997,
    height: 17.9991,
    fill: "white",
    transform: "translate(0.179688 0.46875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEr);
export default __webpack_public_path__ + "static/media/er.400fbf31f9eca9be006b0b2871049777.svg";
export { ForwardRef as ReactComponent };